<!-- 报表  采购报表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form size="medium" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="结算单位名称">
            <el-select filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择结算单位名称" clearable>
              <el-option v-for="item in customer" :key="item.SUPPLIER_ID" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="$_fliterData">筛选</el-button>
            <el-button type="primary" plain @click="$_exportForm" v-if="fun_dic[113080101]">导出</el-button>
            <el-button type="primary" plain @click="exportSupplierPurchaseAmountSummary" v-if="fun_dic[113080102]">
              供应商采购额汇总导出
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column label="序号" prop="index" width="50px"></el-table-column>
          <el-table-column label="结算单位名称" prop="SUPPLIER_NAME" min-width="200px"></el-table-column>
          <el-table-column v-for="item in kinds" :key="item.TYPE_ID" :label="item.TYPE_NAME"
            :prop="String(item.TYPE_ID)"></el-table-column>
          <el-table-column label="合计" prop="TOTAL_FEE_ROW"></el-table-column>
          <el-table-column label="操作" fixed="right" width="70px">
            <template slot-scope="scope">
              <el-button v-if="scope.$index + 1 < tableData.length" type="text" @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { p_salesStatements, p_exportForm } from 'api/returnWare';
import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';

export default {
  data() {
    return {
      PAGE_ID: '1130801',
      fun_dic: { 113080101: 0, 113080102: 0 },
      searchForm: {},
      tableData: [],
      kinds: [],
      customer: [],
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    采购报表存储数据() {
      return this.$store.state.采购报表存储数据;
    },
  },
  created() {
    if (this.采购报表存储数据) {
      this.searchForm = this.采购报表存储数据.CONDITION;
    }
    this.$set(this.searchForm, 'DATE', this.$store.state.PURCHASE_ALL.DATE);
    this.queryData();
    this.queryBeforeFun();
  },
  methods: {
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 导出
    $_exportForm() {
      const params = {
      };
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      if (this.searchForm.DATE) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }
      p_exportForm(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'error' });
        } else {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    $_fliterData() {
      this.queryData();
    },
    // 获取界面数据
    queryData() {
      this.$store.dispatch('PURCHASE_ALL', { DATE: this.searchForm.DATE });
      const params = {
      };
      if (this.searchForm.DATE != null && this.searchForm.DATE.length == 2) {
        if ((new Date(this.searchForm.DATE[1]) - new Date(this.searchForm.DATE[0])) / 86400000 > 31) {
          this.$message.show({ text: '选择的日期范围请不要大于31天', type: 'warning' });
          return;
        }

        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }

      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      p_salesStatements(params).then((result) => {
        if (result.length == 0 || result[0].value.length == 0) {
          this.tableData = [];
          this.kinds = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = result[0].value.map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          this.kinds = result[1].TYPE_LIST;
          this.customer = result[2].value0.SUPPLIER_LIST;

          const lastRow = this.tableData.at(-1);
          lastRow.index = '总计';
          lastRow.SUPPLIER_NAME = '';
          // 将搜索结果和条件存储到vuex中
          this.$store.dispatch('设置采购报表存储数据', {
            CONDITION: this.searchForm,
          });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportSupplierPurchaseAmountSummary() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 89,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.DATE) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }
      http.post(params).then((res) => {
        if (res[0] && res[0].URL[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(res[0].URL[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    detail({ SUPPLIER_ID, SUPPLIER_NAME }) {
      sessionStorage.setItem('purchaseDetailTitle', JSON.stringify({
        SUPPLIER_ID, SUPPLIER_NAME,
      }));
      sessionStorage.setItem('dateRange', JSON.stringify(this.searchForm.DATE || []));
      this.$router.push({ path: '/purchaseDetail/detail' });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableManage/purchase.vue